import {createClient} from '@sanity/client'

export const marketingStudioClient = createClient({
  projectId: '3do82whm',
  dataset: 'next',
  apiVersion: '2022-03-07',
  useCdn: true,
})
